<template>
    <div class="d-flex align-center">
        <img :src="_logo" height="80" width="80" class="ms-2" alt="My MENDELU logo" />
        <span class="text-black font-weight-bold">Moje MENDELU </span>
        <b v-if="currentEnv === 'development'" class="text-secondary ml-2">DEV</b>
        <b v-else-if="currentEnv === 'debug'" class="text-error ml-2">DEBUG</b>
    </div>
</template>

<script setup>
import logo from '../assets/logo.svg?url';
import {computed} from "vue";
import {config} from "@/config";

const currentEnv = computed(() => {
    return config.env;
})

const _logo = computed(() => logo)
</script>

<style scoped>
@media only screen and (max-width: 960px) {
  img {
    height: 60px;
    margin-left: 0px !important;
  }
}
</style>